export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/agreement',
      method: 'GET'
    }]
  }
}